<script lang='ts'>
  import { Li } from "flowbite-svelte"
    import type { Snippet } from 'svelte'
    import { readerFontFamily } from '$lib/reader-fonts'
    import { readerOpts } from '$lib/store'

    interface Props {
        children?: Snippet
        listItemIndex?: number
    }

    // trunk-ignore(eslint/@typescript-eslint/no-unused-vars,eslint/no-unused-vars)
    const { children, listItemIndex = undefined }: Props = $props()
</script>

{#key $readerOpts}
<Li style="font-family: {readerFontFamily($readerOpts.bodyFont)};">{@render children?.()}</Li>
{/key}
